export default "__VITE_ASSET__BYKEhGT1__"